import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAquarius = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 8.4058L6.91203 9.56897C7.69323 10.5653 9.13418 10.7397 10.1305 9.95847C10.4273 9.72571 10.6622 9.42331 10.8141 9.07806L11.4545 7.62319C11.9382 6.52438 13.2211 6.02572 14.3199 6.50941C14.8628 6.74835 15.2844 7.19872 15.4871 7.7561L15.8456 8.74213C16.2783 9.93196 17.5936 10.5458 18.7834 10.1131C19.4207 9.88136 19.9226 9.37939 20.1544 8.74213L20.5129 7.7561C20.9232 6.62782 22.1705 6.04577 23.2988 6.45605C23.8561 6.65874 24.3065 7.08037 24.5455 7.62319L25.1859 9.07806C25.696 10.2368 27.0488 10.7627 28.2076 10.2526C28.5528 10.1006 28.8552 9.86581 29.088 9.56897L30 8.4058",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 27.0724L6.91203 28.2356C7.69323 29.2319 9.13418 29.4063 10.1305 28.6251C10.4273 28.3923 10.6622 28.0899 10.8141 27.7447L11.4545 26.2898C11.9382 25.191 13.2211 24.6923 14.3199 25.176C14.8628 25.415 15.2844 25.8653 15.4871 26.4227L15.8456 27.4088C16.2783 28.5986 17.5936 29.2124 18.7834 28.7797C19.4207 28.548 19.9226 28.046 20.1544 27.4088L20.5129 26.4227C20.9232 25.2944 22.1705 24.7124 23.2988 25.1227C23.8561 25.3254 24.3065 25.747 24.5455 26.2898L25.1859 27.7447C25.696 28.9034 27.0488 29.4293 28.2076 28.9192C28.5528 28.7673 28.8552 28.5324 29.088 28.2356L30 27.0724",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 17.7391L6.91203 18.9022C7.69323 19.8985 9.13418 20.0729 10.1305 19.2917C10.4273 19.059 10.6622 18.7566 10.8141 18.4113L11.4545 16.9564C11.9382 15.8576 13.2211 15.359 14.3199 15.8427C14.8628 16.0816 15.2844 16.532 15.4871 17.0894L15.8456 18.0754C16.2783 19.2652 17.5936 19.879 18.7834 19.4463C19.4207 19.2146 19.9226 18.7126 20.1544 18.0754L20.5129 17.0894C20.9232 15.9611 22.1705 15.379 23.2988 15.7893C23.8561 15.992 24.3065 16.4136 24.5455 16.9564L25.1859 18.4113C25.696 19.5701 27.0488 20.0959 28.2076 19.5859C28.5528 19.4339 28.8552 19.1991 29.088 18.9022L30 17.7391",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAquarius;
